module.exports = __webpack_public_path__ + "static/media/TA274_4.5b133c04.png";